/* VSUAL — Barra de utilidad
   Rota los avisos de uno en uno desplazando la pista.

   Con un solo aviso no hace nada: no arranca el temporizador ni toca el DOM,
   porque una barra que no rota no debe pagar un intervalo cada 4 segundos.

   Se re-ejecuta en el editor de temas, donde las secciones se recargan sin
   recargar la pagina. Por eso todo el bind es idempotente. */
(function () {
  'use strict';

  function initBar(viewport) {
    if (viewport.dataset.vsualBound === 'true') return;
    viewport.dataset.vsualBound = 'true';

    var track = viewport.querySelector('[data-vsual-ubar-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) {
      // Un unico aviso: se deja plantado y visible.
      paint(0, slides);
      return;
    }

    var interval = parseInt(viewport.dataset.interval, 10);
    if (isNaN(interval) || interval < 1000) interval = 4000;

    var index = 0;
    var timer = null;

    function paintAll() {
      track.style.transform = 'translateX(' + (index * -100) + '%)';
      paint(index, slides);
    }

    function advance() {
      index = (index + 1) % slides.length;
      paintAll();
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    // Leer un aviso a medias molesta: al pasar el mouse o al tabular dentro,
    // la rotacion se detiene y se reanuda al salir.
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    viewport.addEventListener('focusin', stop);
    viewport.addEventListener('focusout', start);

    // En una pestana oculta el temporizador solo acumula saltos que nadie ve.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    paintAll();
    start();
  }

  /* Los avisos que no se ven quedan fuera del lector de pantalla y fuera del
     recorrido con Tab: si no, se tabula hacia un enlace invisible. */
  function paint(active, slides) {
    slides.forEach(function (slide, i) {
      var on = i === active;
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      slide.querySelectorAll('a').forEach(function (link) {
        if (on) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vsual-ubar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
